import { TextField } from '@mui/material';
import { regexConstants } from '../../../constants/regEx';

const NumberFilter = ({ filterOption, filterMenu, keyParam, onFieldChange, placeHolder }) => {     
    return(
    <TextField
        id={keyParam}
        label={filterMenu[keyParam].title}
        fullWidth
        size='small'
        margin='normal'
        value={filterOption[keyParam] || ''}
        onChange={(e) => {
            const value = e.target.value;
            if (filterMenu[keyParam]?.is_decimal) {
                if (regexConstants.numberWithDot.test(value)) {
                    onFieldChange(keyParam, value);
                }
            } else {
                const isValidValue = keyParam
                    ? value === "" || regexConstants.positiveIntegerNoZero.test(value)
                    : regexConstants.numberWithDot.test(value);
                isValidValue ? onFieldChange(keyParam, value) : e.preventDefault();
            }
        }}
        slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: filterMenu[keyParam]?.is_decimal ? 11 : 5} }}
        variant='outlined'
        placeholder={placeHolder}
        sx={{ mt: 2.5,'& .MuiOutlinedInput-root': { borderRadius: '5px' } }}
    />
)};

export default NumberFilter;


